import React from 'react';
import * as S from './Styles';

export const ProgressBar = ({ store, progress }) => {
    return (
        <S.ProgressBar>
            <S.ProgressBarLabel>
                {store}:
            </S.ProgressBarLabel>

            <S.ProgressBarWrapper>
                <S.ProgressBarOuter>
                    <S.ProgressBarInner progress={progress} />
                </S.ProgressBarOuter>

                {progress}%
            </S.ProgressBarWrapper>
        </S.ProgressBar>
    )
}
